const state = {
  translationStatus: null
};

const mutations = {
  SET_TRANSLATION_STATUS(state, status) {
    state.translationStatus = status;
  }
};

const actions = {
  initialize({ rootState, dispatch }) {
    rootState.window.windowService.addMessageHandler(data => {
      switch (data.act) {
        case 'inherit_translation_status':
          dispatch('inheritTranslationStatus', data.status);
          break;
        case 'crema_translation_history_changed':
          dispatch('onPopstate', data.status);
          break;
      }
    });
  },
  initTranslationStatus({ rootState }, defaultTranslationStatus) {
    rootState.window.windowService.postMessage('init_translation_status', {
      default_translation_status: defaultTranslationStatus
    });
  },
  inheritTranslationStatus({ commit, dispatch }, newTranslationStatus) {
    commit('SET_TRANSLATION_STATUS', newTranslationStatus);
    dispatch(
      'googleTranslator/inheritTranslationStatus',
      newTranslationStatus,
      {
        root: true
      }
    );
  },
  changeTranslationStatus({ commit, rootState }, newTranslationStatus) {
    commit('SET_TRANSLATION_STATUS', newTranslationStatus);
    rootState.window.windowService.postMessage('translate', {
      status: newTranslationStatus
    });
  },
  onPopstate(
    { rootState, state: { translationStatus } },
    newTranslationStatus
  ) {
    if (translationStatus && translationStatus !== newTranslationStatus) {
      rootState.window.windowService.postMessage('translate', {
        status: translationStatus
      });
    }
  }
};

export default { namespaced: true, state, mutations, actions };
